import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography';
import Title from '@components/Title';
import useSx from './sx';

const Header = () => {
    const sx = useSx()

    return (
        <Box sx={sx.root}>
            <Title text='Mi Perfil' />
        </Box>
    )
}

export default Header